export default "__VITE_ASSET__CKA_5d46__"